import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Paper, AppBar, Toolbar, Divider } from '@mui/material';
import { fetchCompanyInfo } from '../services/companyInfo';

function TermsPage() {
  const [company, setCompany] = useState({ company_name: '', company_phone: '', company_address: '' });
  useEffect(() => { fetchCompanyInfo().then(setCompany).catch(() => {}); }, []);
  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: '#1976d2' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {company.company_name || ''}
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={1} sx={{ p: { xs: 3, md: 5 } }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1 }}>
            이용약관
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 4 }}>
            시행일: 2026년 2월 10일
          </Typography>

          <Section title="제1조 (목적)">
            이 약관은 {company.company_name || ''}(이하 "회사")가 제공하는 화물 운송 매칭 플랫폼 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자(이하 "회원") 사이의 권리·의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
          </Section>

          <Section title="제2조 (용어의 정의)">
            <NumberedList items={[
              '"서비스"란 회사가 제공하는 화물 운송 매칭, 배차, 운송 관리, 정산 등 관련 제반 서비스를 의미합니다.',
              '"회원"이란 회사와 서비스 이용계약을 체결하고 회원 계정을 부여받은 자를 말합니다.',
              '"운전자 회원"이란 화물자동차 운송사업 면허를 보유하고, 회사의 플랫폼을 통해 화물 운송 서비스를 제공하는 회원을 말합니다.',
              '"배차"란 화물 운송 의뢰에 대해 운전자를 배정하는 것을 의미합니다.',
              '"앱"이란 회사가 서비스 제공을 위해 운영하는 모바일 애플리케이션을 의미합니다.',
            ]} />
          </Section>

          <Section title="제3조 (약관의 효력 및 변경)">
            <NumberedList items={[
              '이 약관은 서비스를 이용하고자 하는 모든 회원에게 적용됩니다.',
              '회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.',
              '약관이 변경되는 경우 회사는 변경 내용을 시행일 7일 전부터 앱 내 공지사항 또는 푸시 알림을 통해 공지합니다.',
              '회원이 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.',
            ]} />
          </Section>

          <Section title="제4조 (서비스 이용계약의 체결)">
            <NumberedList items={[
              '서비스 이용계약은 회원이 되고자 하는 자가 약관에 동의하고 회원가입을 신청한 후, 회사가 이를 승인함으로써 체결됩니다.',
              <>회사는 다음 각 호에 해당하는 경우 회원가입을 거절하거나 사후에 이용계약을 해지할 수 있습니다.
                <SubList items={[
                  '가입 신청 시 허위 정보를 기재한 경우',
                  '타인의 명의를 도용한 경우',
                  '관련 법령을 위반하거나 사회의 안녕과 질서, 미풍양속을 저해할 목적으로 신청한 경우',
                  '이전에 서비스 이용 자격을 상실한 적이 있는 경우',
                ]} />
              </>,
              '운전자 회원은 본인인증 절차를 완료하여야 하며, 관리자의 승인 후 배차 서비스를 이용할 수 있습니다.',
            ]} />
          </Section>

          <Section title="제5조 (서비스의 내용)">
            <Typography variant="body1" paragraph>
              회사가 제공하는 서비스는 다음과 같습니다.
            </Typography>
            <NumberedList items={[
              '화물 운송 배차 매칭 서비스',
              '실시간 배차 알림(푸시 알림) 서비스',
              '배송 현황 관리 서비스',
              '운송료 정산 서비스',
              '위치정보 기반 운송 관리 서비스',
              '기타 회사가 추가 개발하거나 제휴를 통해 제공하는 서비스',
            ]} />
          </Section>

          <Section title="제6조 (서비스 이용시간 및 중단)">
            <NumberedList items={[
              '서비스는 연중무휴 24시간 제공함을 원칙으로 합니다.',
              <>회사는 다음 각 호의 경우에 서비스의 전부 또는 일부를 일시적으로 중단할 수 있습니다.
                <SubList items={[
                  '시스템 정기점검, 서버 증설 및 교체, 네트워크 불안정 등의 시스템 운영상 필요한 경우',
                  '정전, 서비스 설비의 장애 또는 이용량 폭주 등으로 정상적인 서비스 제공이 곤란한 경우',
                  '천재지변, 국가비상사태 등 불가항력적인 사유가 발생한 경우',
                ]} />
              </>,
              '서비스 중단의 경우 회사는 사전에 앱을 통해 공지합니다. 다만, 긴급한 경우 사후에 공지할 수 있습니다.',
            ]} />
          </Section>

          <Section title="제7조 (회원의 의무)">
            <NumberedList items={[
              '회원은 관계 법령, 이 약관의 규정, 이용안내 및 서비스와 관련한 회사의 공지사항을 준수하여야 합니다.',
              <>회원은 다음 행위를 하여서는 안 됩니다.
                <SubList items={[
                  '서비스 이용 신청 또는 변경 시 허위 정보를 등록하는 행위',
                  '타인의 정보를 도용하는 행위',
                  '서비스를 이용하여 법령 또는 공서양속에 반하는 행위',
                  '회사의 서비스 운영을 방해하는 행위',
                  '회사의 사전 동의 없이 서비스를 영리 목적으로 이용하는 행위',
                ]} />
              </>,
              '운전자 회원은 배차를 수락한 화물에 대해 성실히 운송 의무를 이행하여야 합니다.',
              '운전자 회원은 차량 보험, 운전면허 등 관련 자격을 항상 유효한 상태로 유지하여야 합니다.',
              '회원은 계정 정보(전화번호, PIN 등)를 안전하게 관리하여야 하며, 이를 제3자에게 양도하거나 대여할 수 없습니다.',
            ]} />
          </Section>

          <Section title="제8조 (회사의 의무)">
            <NumberedList items={[
              '회사는 관련 법령과 이 약관을 준수하며, 지속적이고 안정적으로 서비스를 제공하기 위해 최선을 다합니다.',
              '회사는 회원의 개인정보를 관련 법령에 따라 안전하게 보호합니다.',
              '회사는 서비스 이용과 관련한 회원의 불만 또는 피해 구제 요청을 적절히 처리하기 위한 체계를 갖추어야 합니다.',
            ]} />
          </Section>

          <Section title="제9조 (배차 및 운송)">
            <NumberedList items={[
              '배차는 회사의 시스템을 통해 이루어지며, 운전자 회원이 배차 요청에 신청하고 관리자가 승인하는 방식으로 진행됩니다.',
              '운전자 회원은 배차를 수락한 후 정당한 사유 없이 이를 취소할 수 없습니다.',
              '운송 요금은 배차 시 확정된 금액을 기준으로 정산됩니다.',
              '회사는 배차 매칭의 공정성을 위해 노력하며, 운전자의 차량 종류, 위치, 평점 등을 고려하여 배차를 진행합니다.',
            ]} />
          </Section>

          <Section title="제10조 (정산)">
            <NumberedList items={[
              '운송료 정산은 회사가 정한 기준에 따라 이루어집니다.',
              '회원이 등록한 은행 계좌로 운송료가 지급되며, 계좌 정보 오류로 인한 지급 지연에 대해 회사는 책임지지 않습니다.',
              '운송료에서 플랫폼 이용 수수료가 공제될 수 있으며, 수수료율은 사전에 회원에게 고지됩니다.',
            ]} />
          </Section>

          <Section title="제11조 (이용계약의 해지 및 자격 제한)">
            <NumberedList items={[
              '회원이 서비스 이용계약을 해지하고자 하는 경우, 회사에 해지 의사를 통지하여야 합니다.',
              <>회사는 다음 각 호의 사유에 해당하는 경우 이용계약을 해지하거나 서비스 이용을 제한할 수 있습니다.
                <SubList items={[
                  '이 약관을 위반한 경우',
                  '허위 정보를 등록하거나 타인의 정보를 도용한 경우',
                  '서비스의 정상적인 운영을 방해한 경우',
                  '관련 법령을 위반한 경우',
                  '장기간(6개월 이상) 서비스를 이용하지 않는 경우',
                ]} />
              </>,
              '이용계약이 해지된 경우, 회원의 정보는 관련 법령에 따라 일정 기간 보관 후 삭제됩니다.',
            ]} />
          </Section>

          <Section title="제12조 (손해배상)">
            <NumberedList items={[
              '회사는 무료로 제공하는 서비스의 이용과 관련하여 회원에게 발생한 손해에 대해 배상 책임을 지지 않습니다. 다만, 회사의 고의 또는 중대한 과실로 인한 경우는 예외로 합니다.',
              '회원이 이 약관을 위반하여 회사에 손해를 끼친 경우, 해당 회원은 회사에 발생한 손해를 배상하여야 합니다.',
              '화물 운송 중 발생한 화물의 파손, 분실, 지연 등에 대한 책임은 해당 운송을 수행한 운전자 회원에게 있습니다.',
            ]} />
          </Section>

          <Section title="제13조 (면책조항)">
            <NumberedList items={[
              '회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지 등 불가항력으로 인해 서비스를 제공할 수 없는 경우 책임을 면합니다.',
              '회사는 회원의 귀책사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.',
              '회사는 회원이 서비스를 이용하여 기대하는 수익을 얻지 못한 것에 대해 책임을 지지 않습니다.',
              '회사는 운전자 회원과 화주(의뢰인) 간의 운송 계약에 대해 직접적인 당사자가 아니며, 이에 따른 분쟁에 대해 개입할 의무를 부담하지 않습니다.',
            ]} />
          </Section>

          <Section title="제14조 (분쟁 해결)">
            <NumberedList items={[
              '회사와 회원 간에 발생한 분쟁에 관한 소송은 회사의 본사 소재지를 관할하는 법원을 제1심 관할 법원으로 합니다.',
              '회사와 회원 간에 발생한 전자상거래 분쟁에 대해 회원의 피해구제 신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.',
            ]} />
          </Section>

          <Section title="부칙">
            <Typography variant="body1">
              이 약관은 2026년 2월 10일부터 시행합니다.
            </Typography>
          </Section>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ textAlign: 'center', color: 'text.secondary' }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{company.company_name || ''}</Typography>
            {company.company_phone && <Typography variant="body2">대표전화: {company.company_phone}</Typography>}
            {company.company_address && <Typography variant="body2">주소: {company.company_address}</Typography>}
          </Box>
        </Paper>
      </Container>
    </>
  );
}

function Section({ title, children }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1.5, color: '#1976d2' }}>
        {title}
      </Typography>
      {typeof children === 'string' ? (
        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>{children}</Typography>
      ) : (
        children
      )}
    </Box>
  );
}

function NumberedList({ items }) {
  return (
    <Box component="ol" sx={{ pl: 3, m: 0 }}>
      {items.map((item, index) => (
        <Box component="li" key={index} sx={{ mb: 1 }}>
          <Typography variant="body1" component="div" sx={{ lineHeight: 1.8 }}>
            {item}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

function SubList({ items }) {
  return (
    <Box component="ul" sx={{ pl: 3, mt: 0.5 }}>
      {items.map((item, index) => (
        <Box component="li" key={index} sx={{ mb: 0.5 }}>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>{item}</Typography>
        </Box>
      ))}
    </Box>
  );
}

export default TermsPage;
